import React, { useState, memo, useCallback } from "react";

import { NewOption } from '../parts/NewOption';
import { EditOption } from '../parts/EditOption';

export const ClinicServiceOption = (props) => {
  const { init_clinic_service, options } = props;
  const [currentServiceOptions, setCurrentServiceOptions] = useState(init_clinic_service.service_options);

  const addServiceOption = useCallback((new_item) => {
    setCurrentServiceOptions([...currentServiceOptions, new_item]);
  }, [currentServiceOptions]);

  const removeServiceOption = useCallback((remove_item) => {
    setCurrentServiceOptions(currentServiceOptions.filter(item => {
      return item.id !== remove_item;
    }));
  }, [currentServiceOptions]);

  return (
    <>
      <NewOption clinic_service_id={init_clinic_service.id} options={options} addServiceOption={addServiceOption} />
      <div className="row">
        <table className="table table-striped table-hover mb-3">
          <tbody>
            {currentServiceOptions.map(service_option => 
              <EditOption key={service_option.id} init_service_option={service_option} removeServiceOption={removeServiceOption} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};